/**
 * The user's own name for a discontinuity (J1, J2, …). Optional, and asked
 * last on every source so the guided walk never stalls on it. It is shown in
 * the Inputs table rather than on the log, where the colours already tell the
 * traces apart.
 */
export const LABEL_FIELD = {
  id: "dlabel",
  name: "dlabel",
  label: "Discontinuity Label",
  type: "text",
  placeholder: "e.g. J1",
  maxLength: 8,
};

/** Text for the Inputs-table Label cell. */
export const labelCell = (dimension) => {
  const v = dimension && dimension.dlabel;
  return v === undefined || v === null || String(v).trim() === "" ? "-" : String(v).trim();
};

/** The last field that fixes the data location: everything but the label. */
export const finalLocationField = (fields) =>
  fields.filter((f) => f.id !== LABEL_FIELD.id).slice(-1)[0];
